const POINTS_PER_DOLLAR = 1;
// 100 points = $5 OFF
const DOLLAR_PER_POINT = 0.05;

export const EarnPoints = ({ price }: { price: number }) => {
  const points = Math.floor((price || 0) * POINTS_PER_DOLLAR);

  if (!points) {
    return null;
  }

  const value = (points * DOLLAR_PER_POINT).toFixed(2);

  return (
    <span className='font-roboto-medium text-sm font-medium leading-none text-e82f2f lg_text-lg'>
      Earn {points} Points (${value} value)
    </span>
  );
};
